export default __webpack_public_path__ + "8145899d3e6533d1817d122c75eb44d2.woff2";